/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ChevronLeftLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="chevron-left-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M356.6033333333334 680L906.6666666666666 1230.0633333333333L986.7933333333334 1149.9366666666667L516.8566666666667 680L986.7933333333334 210.0633333333335L906.6666666666666 129.9366666666667L356.6033333333334 680z" : "M285.2826666666667 544L725.3333333333334 984.0506666666666L789.4346666666668 919.9493333333334L413.4853333333334 544L789.4346666666668 168.0506666666667L725.3333333333334 103.9493333333332L285.2826666666667 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ChevronLeftLg.displayName = `Blueprint5.Icon.ChevronLeftLg`;
export default ChevronLeftLg;
